import { useEffect } from 'react';

export type ToastType = 'error' | 'success';

type Props = {
  message: string;
  onClose: () => void;
  /** Toast type: error (red) or success (green). */
  type?: ToastType;
  /** Auto-hide after this many ms. Default 2000. */
  duration?: number;
};

const typeStyles: Record<ToastType, string> = {
  error: 'bg-red-600 text-white',
  success: 'bg-green-600 text-white',
};

export function Toast({
  message,
  onClose,
  type = 'error',
  duration = 2000,
}: Props) {
  useEffect(() => {
    const id = window.setTimeout(onClose, duration);
    return () => window.clearTimeout(id);
  }, [message, duration, onClose]);

  return (
    <div
      className="fixed top-6 left-1/2 -translate-x-1/2 z-[100] w-full max-w-sm px-4 animate-toast-in"
      role="alert"
    >
      <div className={`rounded-lg px-4 py-3 shadow-lg ${typeStyles[type]}`}>
        <p className="text-sm font-medium">{message}</p>
      </div>
    </div>
  );
}
